import { useCallback } from 'react';
import { ExclamationCircleIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { atom, useAtom } from 'jotai';

import { Heading, Button, Modal, ModalContent } from '@restworld/ui-ds-base';

import { useDeleteCv } from './hooks/use-delete-cv';

export const showDeleteCVModalAtom = atom<boolean>(false);
export const DeleteWorkerCv = ({ showDeleteCvButton = true }: { showDeleteCvButton?: boolean }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useAtom(showDeleteCVModalAtom);

  const onClose = useCallback(() => {
    setShowModal(false);
  }, [setShowModal]);

  const openModal = useCallback(() => {
    setShowModal(true);
  }, [setShowModal]);

  const { handleDelete, isLoading } = useDeleteCv({ onClose });
  return (
    <>
      {showDeleteCvButton && (
        <Button variant="tertiary" className={'p-2.5 focus:ring-0'} onClick={openModal}>
          <TrashIcon className="text-red-600 w-5 h-5" />
        </Button>
      )}
      <Modal open={showModal} onOpenChange={(v) => !v && onClose()}>
        <ModalContent variant="center" className="lg:min-w-[31.75rem] lg:max-w-[31.75rem] bg-gray-50">
          <div className="flex flex-col items-center w-full">
            <ExclamationCircleIcon className="w-[42px] h-[42px] text-red-600" />
            <Heading size={3} className="mt-4 mb-[43px] text-center max-w-[327px]">
              {t('onboarding-page:deleting_resume')}
            </Heading>
            <div className="flex flex-col w-full gap-4">
              <Button type="submit" loading={isLoading} fullwidth={true} onClick={handleDelete}>
                {t('common:continue')}
              </Button>
              <Button variant="secondary-neutral" fullwidth={true} onClick={onClose}>
                {t('common:cancel')}
              </Button>
            </div>
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};
